import { createContext, useContext } from 'react';
import type { Loan } from '../LoansDashboard';

export interface LoanContextType {
  loan: Loan | null;
  loading: boolean;
  error: string | null;
  refetch: () => void;
  refreshTrigger: number;
  triggerRefresh: () => void;
}

export const LoanContext = createContext<LoanContextType | undefined>(undefined);

export function useLoanContext() {
  const ctx = useContext(LoanContext);
  if (!ctx) throw new Error('useLoanContext must be used within a LoanProvider');
  return ctx;
}

export const LoanProvider = LoanContext.Provider; 
